@if (request(); as req) {
  <cads-main-template-modal
    [config]="req.modal"
    (dismissed)="_onDismissed(req)"
    (secondaryTapped)="_onSecondary(req)"
    (primaryTapped)="_onPrimary(req)"
  >
    @if (req.simpleBody?.heroIcon; as heroIcon) {
      <div cads-main-hero class="cads-global-modal-host__hero">
        <cads-icon-view-bit [config]="heroIcon" />
      </div>
    } @else if (req.simpleBody?.heroImage; as heroImage) {
      <div cads-main-hero class="cads-global-modal-host__hero">
        <img
          class="cads-global-modal-host__hero-image"
          [src]="heroImage.src"
          [attr.alt]="heroImage.alt ?? ''"
        />
      </div>
    }

    <div cads-main-body class="cads-global-modal-host__body">
      @if (req.bodyTemplateRef) {
        <ng-container [ngTemplateOutlet]="req.bodyTemplateRef" />
      } @else if (req.simpleBody; as body) {
        @if (body.text) {
          @if (body.html) {
            <p class="cads-global-modal-host__simple-copy" [innerHTML]="body.text"></p>
          } @else {
            <p class="cads-global-modal-host__simple-copy">{{ body.text }}</p>
          }
        }
        @if (body.confirmation; as confirmation) {
          <label class="cads-global-modal-host__confirm-label">
            <input
              type="checkbox"
              class="cads-global-modal-host__confirm-input"
              [checked]="req.confirmationState?.checked ?? false"
              (change)="_onConfirmationChange(req, $event)"
            />
            @if (confirmation.html) {
              <span class="cads-global-modal-host__confirm-text" [innerHTML]="confirmation.label"></span>
            } @else {
              <span class="cads-global-modal-host__confirm-text">{{ confirmation.label }}</span>
            }
          </label>
        }
      } @else {
        <ng-container #bodyHost />
      }
    </div>
  </cads-main-template-modal>
}
